<template>
    <div>
        <b-row>
            <b-col cols="12" md="12">
                <b-button
                    class="mb-2"
                    variant="primary"
                    @click="openReferenceModal(null)"
                    >{{ $t("reference_add_btn") }}</b-button
                >
            </b-col>
            <b-col cols="12" md="12">
                <b-table
                    :empty-filtered-text="$t('no_result')"
                    :empty-text="$t('no_result')"
                    bordered
                    responsive
                    sticky-header
                    :items="referenceTableData"
                    :fields="referenceFields"
                    show-empty
                    class="mb-4 table-dropdown no-scrollbar border rounded"
                >
                    <template #cell(buttons)="row">
                        <b-dropdown
                            variant="link btn-sm"
                            boundary="window"
                            no-caret
                        >
                            <template #button-content>
                                <i class="ri-more-fill"></i>
                            </template>
                            <div id="dropdownListHead">
                                <b-dropdown-item
                                    @click="openEvaluateModal(row.item)"
                                >
                                    <i
                                        class="ri-award-fill align-middle top-minus-1 mr-3 text-muted"
                                    ></i>
                                    {{ $t("evaluate") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                    @click="openReferenceModal(row.item)"
                                >
                                    <i
                                        class="ri-edit-box-line align-middle top-minus-1 mr-3 text-muted"
                                    ></i>
                                    {{ $t("edit") }}
                                </b-dropdown-item>
                                <b-dropdown-item
                                    @click="deleteReferance(row.item)"
                                >
                                    <i
                                        class="ri-delete-bin-2-line align-middle top-minus-1 mr-3 text-muted"
                                    ></i>
                                    {{ $t("delete") }}
                                </b-dropdown-item>
                            </div>
                        </b-dropdown>
                    </template>
                    <template #cell(letter_of_reference)="row">
                        <b-button
                            variant="info"
                            @click="downloadReferenceLetter(row.item.id)"
                            >{{ $t("download") }}
                        </b-button>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <CommonModal ref="referenceModal" size="lg">
            <template v-slot:CommonModalTitle>
                <div>{{ referenceModalTitle }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <ValidationObserver ref="referenceFormValidate">
                    <b-row>
                        <b-col cols="6">
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group :label="$t('name')">
                                        <ValidationProvider
                                            name="name"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                v-model="referenceFormData.name"
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                            />
                                            <div
                                                class="invalid-feedback d-block"
                                                v-if="errors[0]"
                                                v-html="errors[0]"
                                            ></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group :label="$t('surname')">
                                        <ValidationProvider
                                            name="surname"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                v-model="
                                                    referenceFormData.surname
                                                "
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                            />
                                            <div
                                                class="invalid-feedback d-block"
                                                v-if="errors[0]"
                                                v-html="errors[0]"
                                            ></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('mission')">
                                        <ValidationProvider
                                            name="reference_post"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                v-model="
                                                    referenceFormData.reference_post
                                                "
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                            />
                                            <div
                                                class="invalid-feedback d-block"
                                                v-if="errors[0]"
                                                v-html="errors[0]"
                                            ></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('gsm_no')">
                                        <ValidationProvider
                                            name="phone"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                v-model="
                                                    referenceFormData.phone
                                                "
                                                v-mask="'### ### ## ##'"
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                            />
                                            <div
                                                class="invalid-feedback d-block"
                                                v-if="errors[0]"
                                                v-html="errors[0]"
                                            ></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('email')">
                                        <ValidationProvider
                                            name="email"
                                            rules="required|email"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                v-model="
                                                    referenceFormData.email
                                                "
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                            />
                                            <div
                                                class="invalid-feedback d-block"
                                                v-if="errors[0]"
                                                v-html="errors[0]"
                                            ></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="12" lg="12" class="mt-5">
                                    <ValidationProvider
                                        name="letter_of_reference"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <b-input-group class="mb-0 mt-1">
                                            <b-form-file
                                                v-model="
                                                    referenceFormData.letter_of_reference
                                                "
                                                :placeholder="
                                                    $t('letter_of_reference')
                                                "
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                                ref="fileInput3"
                                            />
                                            <b-input-group-append>
                                                <b-button
                                                    variant="outline-secondary"
                                                    @click="
                                                        $refs.fileInput3.$el.childNodes[0].click()
                                                    "
                                                    >{{
                                                        $t("browse")
                                                    }}</b-button
                                                >
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-form-invalid-feedback
                                            v-if="errors[0]"
                                            v-html="errors[0]"
                                        />
                                        <b-button
                                            variant="outline-primary"
                                            class="mb-4 mt-2"
                                            v-if="
                                                referenceFormData.letter_of_reference &&
                                                referenceFormData.id
                                            "
                                            @click="
                                                downloadReferenceLetter(
                                                    referenceFormData.id
                                                )
                                            "
                                        >
                                            <i
                                                class="ri-download-2-line font-size-16 mr-2"
                                            ></i>
                                            {{ $t("file_download") }}
                                        </b-button>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="6">
                            <b-alert show variant="info">{{
                                $t("reference_letter_warning")
                            }}</b-alert>
                        </b-col>
                        <b-col
                            cols="12"
                            class="d-flex justify-content-center mb-3 mt-4"
                        >
                            <b-button
                                variant="primary"
                                @click="addToReferences"
                                >{{ $t("save") }}</b-button
                            >
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </template>
        </CommonModal>

        <CommonModal ref="evaluateModal" size="md">
            <template v-slot:CommonModalTitle>
                <div>{{ $t("evaluation") }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <ValidationObserver ref="evaluateFormValidate">
                    <b-row>
                        <b-col cols="12">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group :label="$t('score')">
                                        <ValidationProvider
                                            name="point"
                                            rules="required|dynamic_between:0,100"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                v-model="evaluateFormData.point"
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                            />
                                            <div
                                                class="invalid-feedback d-block"
                                                v-if="errors[0]"
                                                v-html="errors[0]"
                                            ></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('status')">
                                        <ValidationProvider
                                            name="reference_status"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <multi-selectbox
                                                v-model="
                                                    evaluateFormData.reference_status
                                                "
                                                :options="
                                                    referenceStatusOptions
                                                "
                                                :multiple="false"
                                                :validateError="errors[0]"
                                            />
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('description')">
                                        <ValidationProvider
                                            name="reference_description"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-textarea
                                                v-model="
                                                    evaluateFormData.reference_description
                                                "
                                                rows="3"
                                                :state="
                                                    errors[0] ? false : null
                                                "
                                            />
                                            <div
                                                class="invalid-feedback d-block"
                                                v-if="errors[0]"
                                                v-html="errors[0]"
                                            ></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col
                            cols="12"
                            class="d-flex justify-content-center mb-3 mt-4"
                        >
                            <b-button
                                variant="primary"
                                @click="evaluateReference"
                                >{{ $t("save") }}</b-button
                            >
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </template>
        </CommonModal>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CommonModal from "@/components/elements/CommonModal";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import BisepService from "@/services/BisepService";
import qs from "qs";

export default {
    name: "ReferenceTab",
    components: {
        ValidationObserver,
        ValidationProvider,
        CommonModal,
        MultiSelectbox,
    },
    props: {
        formId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            referenceTableData: [],
            referenceFields: [
                { key: "buttons", label: "" },
                { key: "name", label: this.$t("name") },
                { key: "surname", label: this.$t("surname") },
                { key: "reference_post", label: this.$t("mission") },
                { key: "phone", label: this.$t("gsm_no") },
                { key: "email", label: this.$t("email") },
                { key: "reference_create_date", label: this.$t("added_date") },
                {
                    key: "reference_approve_date",
                    label: this.$t("approve_date"),
                },
                { key: "point", label: this.$t("score") },
                { key: "reference_status", label: this.$t("status") },
                { key: "reference_description", label: this.$t("description") },
                { key: "status_date", label: this.$t("status_date") },
                { key: "last_updated", label: this.$t("last_updated") },
                {
                    key: "letter_of_reference",
                    label: this.$t("letter_of_reference"),
                },
            ],
            referenceFormData: {},
            evaluateFormData: {},
            referenceModalTitle: null,
            referenceStatusOptions: [
                { value: "approved", text: this.$t("approved") },
                { value: "rejected", text: this.$t("rejected") },
            ],
        };
    },
    created() {
        this.fetchReferences();
    },
    methods: {
        async fetchReferences() {
            try {
                const config = {
                    params: {
                        filter: { bisep_application_id: this.formId },
                    },
                    paramsSerializer: (params) =>
                        qs.stringify(params, { encode: false }),
                };
                const res = await BisepService.adminGetReferences(config);
                this.referenceTableData = res.data.data;
            } catch (err) {
                this.showErrors(err);
            }
        },
        openReferenceModal(data) {
            if (data != null) {
                this.referenceModalTitle = this.$t("edit");
                this.referenceFormData = { ...data };
            } else {
                this.referenceModalTitle = this.$t("reference");
                this.referenceFormData = {};
            }
            this.$refs.referenceModal.$refs.commonModal.show();
        },
        async addToReferences() {
            const isValid = await this.$refs.referenceFormValidate.validate();
            if (isValid) {
                let formData = new FormData();
                if (this.referenceFormData.phone) {
                    this.referenceFormData.phone =
                        this.referenceFormData.phone.replace(/[^\d]/g, "");
                }

                for (let key in this.referenceFormData) {
                    if (
                        this.referenceFormData[key] !== null &&
                        this.referenceFormData[key] !== undefined
                    ) {
                        formData.append(key, this.referenceFormData[key]);
                    }
                }

                if (this.referenceFormData.hasOwnProperty("id")) {
                    formData.append("_method", "PUT");
                    BisepService.updateAdminReference(
                        this.referenceFormData.id,
                        formData
                    )
                        .then((res) => {
                            this.$toast.success(
                                this.$t("api." + res.data.message)
                            );
                            this.fetchReferences();
                            this.referenceFormData = {};
                            this.$refs.referenceFormValidate.reset();
                            this.$refs.referenceModal.$refs.commonModal.hide();
                        })
                        .catch((e) => {
                            this.showErrors(
                                e,
                                this.$refs.referenceFormValidate
                            );
                        });
                } else {
                    formData.append("bisep_application_id", this.formId);
                    BisepService.addAdminReference(formData)
                        .then((res) => {
                            this.$toast.success(
                                this.$t("api." + res.data.message)
                            );
                            this.fetchReferences();
                            this.referenceFormData = {};
                            this.$refs.referenceFormValidate.reset();
                            this.$refs.referenceModal.$refs.commonModal.hide();
                        })
                        .catch((e) => {
                            this.showErrors(
                                e,
                                this.$refs.referenceFormValidate
                            );
                        });
                }
            }
        },
        deleteReferance(data) {
            this.$swal
                .fire({
                    text: this.$t("are_you_sure_to_delete"),
                    showCancelButton: true,
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        BisepService.deleteAdminReference(data.id)
                            .then((res) => {
                                this.$toast.success(
                                    this.$t("api." + res.data.message)
                                );
                                this.fetchReferences();
                            })
                            .catch((e) => {
                                this.showErrors(e);
                            });
                    }
                });
        },
        openEvaluateModal(data) {
            this.evaluateFormData = { ...data };
            this.$refs.evaluateModal.$refs.commonModal.show();
        },
        async evaluateReference() {
            const isValid = await this.$refs.evaluateFormValidate.validate();
            if (isValid) {
                let formData = new FormData();
                formData.append("_method", "PUT");
                for (let key in this.evaluateFormData) {
                    if (
                        this.evaluateFormData[key] !== null &&
                        this.evaluateFormData[key] !== undefined
                    ) {
                        formData.append(key, this.evaluateFormData[key]);
                    }
                }
                BisepService.updateAdminReference(
                    this.evaluateFormData.id,
                    formData
                )
                    .then((res) => {
                        this.$toast.success(this.$t("api." + res.data.message));
                        this.fetchReferences();
                        this.evaluateFormData = {};
                        this.$refs.evaluateFormValidate.reset();
                        this.$refs.evaluateModal.$refs.commonModal.hide();
                    })
                    .catch((e) => {
                        this.showErrors(e, this.$refs.evaluateFormValidate);
                    });
            }
        },
        downloadReferenceLetter(id) {
            BisepService.adminDownloadReferenceLetter(id)
                .then((response) => {
                    this._downloadFile(
                        response,
                        this.$t("letter_of_reference") +
                            "." +
                            response.headers.file_extension
                    );
                })
                .catch((e) => {
                    this.showErrors(e, null);
                });
        },
    },
};
</script>
